import kr from 'Kr/kr';
import HTMLCLass from '../../kr/utils/HTMLClass';

export default class Tabs extends kr.Component {
    init() {
        this.lis = this.$element.querySelectorAll('.tabs__nav__li');
        this.tabs = this.$element.querySelectorAll('.js-tabs-items [data-tab]');
        this.navFixed = this.$element.querySelector('.js-tabsNavFixed');
        this.navFixedSep = this.$element.querySelector('.js-tabsNavSep');
        this.scrollAfterNavChanged = this.$element.getAttribute('data-scroll-nav') ?? 0;
        this.afterLoad = false;
        this.header = document.getElementById('ast-mobile-header');
        if (!this.lis) {
            return;
        }
        this.activeElement = this._getHash();
        if (!this.activeElement) {
            this.activeElement = this.lis[0].getAttribute('data-tab');
        }

        this._changeElement();

        this.bind();
    }

    bind() {
        this.on('click', '.tabs__nav__li', (target, event) => {
            event.preventDefault();
            this.activeElement = target.getAttribute('data-tab');
            this._changeElement();

        });

        if (this.navFixed && this.navFixedSep) {
            this.setNavFixed();
            window.addEventListener('scroll', this.setNavFixed.bind(this), true);
        }

        window.addEventListener('load', () => {
            this.afterLoad = true;
        });
        /*
        addEventListener('hashchange', (event) => {
            this.activeElement = this._getHash();
            if (!this.activeElement) {
                this.activeElement = this.lis[0].getAttribute('data-tab');
            }

            /*window.scrollTo({
                top: this.lis[0].offsetTop - 150,
                behavior: 'smooth'
            })
        });*/

    }

    _changeElement() {
        if (!this.$element.querySelector(`.tabs__nav__li[data-tab="${this.activeElement}"]`)) {
            this.activeElement = this.lis[0].getAttribute('data-tab');
        }
        for (let i in this.lis) {
            if (!this.lis.hasOwnProperty(i)) {
                continue;
            }
            const li = this.lis[i];
            const tabName = li.getAttribute('data-tab');
            const tab = this._getTab(tabName);
            if (typeof tab === 'undefined' || ! tab) {
                HTMLCLass.removeClass(li, 'tabs__nav__li--active');
                continue;
            }
            if (tabName == this.activeElement) {
                if (this.scrollAfterNavChanged && this.afterLoad) {
                    history.pushState(null, null, `#${this.activeElement}`);
                    this.$element.scrollIntoView();
                }
                HTMLCLass.addClass(li, 'tabs__nav__li--active');
                HTMLCLass.addClass(tab, 'tabs__tab--active');
                setTimeout(() => {
                    HTMLCLass.addClass(tab, 'tabs__tab--active--animated');
                },100);
            } else {
                HTMLCLass.removeClass(li, 'tabs__nav__li--active');
                HTMLCLass.removeClass(tab, 'tabs__tab--active');
                HTMLCLass.removeClass(tab, 'tabs__tab--active--animated');

            }
        }
    }

    setNavFixed()
    {
        const tolerance = window.innerWidth > 1023 ? 88 : 70;
        if (this._isElementNearTopOfViewport(this.$element, tolerance) && this._isElementInViewport(this.$element)) {
            this.navFixedSep.style.height = `${this.navFixed.offsetHeight}px`;
            this.navFixed.style.top = `${tolerance}px`;
            HTMLCLass.addClass(this.$element, 'js-tabsNavFixed--active');
        } else {
            HTMLCLass.removeClass(this.$element, 'js-tabsNavFixed--active');
        }
    }

    _getTab(name) {
        return this.$element.querySelector(`.js-tabs-items [data-tab="${name}"]`);
    }
    _getHash() {
        return window.location.hash ? window.location.hash.replace('#', '') : false
    }

    _isElementNearTopOfViewport(element, tolerance = 0) {
        const rect = element.getBoundingClientRect();
        return rect.top <= tolerance;
    }
    _isElementInViewport(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      
        return (
          rect.top < windowHeight &&
          rect.bottom > 0
        );
      }
}

kr.registerComponent('.js-tabs', {
    component: Tabs
});